'use strict';

/* global grecaptcha */

import Vue from 'vue';
import axios from 'axios';

const SELECTOR = '.feature-newsletter, .newsletter';

document.querySelectorAll(SELECTOR).forEach(el => {
    new Vue({
        el,
        data: {
            processing: false,
            finished: false,
            error_msg: '',
            complete_msg: '',
        },
        methods: {
            onFormSubmit: function onFormSubmit(ev) {
                this.error_msg = '';
                ev.preventDefault();
                this.processing = true;
                const that = this;

                grecaptcha.ready(function() {
                    grecaptcha.execute(
                        ev.target.dataset.recaptchaKey, // Gets the Recaptcha Key from the form
                        {
                            action: 'submit'
                        })
                            .then(function(token) {
                                const basicAuth = ev.target.dataset.basicAuth ? JSON.parse(ev.target.dataset.basicAuth) : false;

                                const options = {};
                                const data = new FormData(ev.target);
                                data.append('isajax', true);
                                data.append('token', token);

                                if (basicAuth) {
                                    options.auth = {
                                        username: basicAuth[0],
                                        password: basicAuth[1],
                                    }
                                }

                                axios.post(ev.target.action, data, options).then(res => {
                                    if (res.data.status === 'error') {
                                        that.error_msg = res.data.data;
                                    } else {
                                        that.finished = true;
                                        that.complete_msg = res.data.data;
                                    }
                                }).finally(() => {
                                    that.processing = false;
                                });
                        });
                });
            }
        }
    });
});
